/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRoundaboutRight = createReactComponent("outline", "arrow-roundabout-right", "IconArrowRoundaboutRight", [["path", { "d": "M21 9h-8a5 5 0 1 0 -5 5v7", "key": "svg-0" }], ["path", { "d": "M17 5l4 4l-4 4", "key": "svg-1" }]]);

export { IconArrowRoundaboutRight as default };
//# sourceMappingURL=IconArrowRoundaboutRight.mjs.map
